/**
 * Stores a text input, and possibly filters, and calls "this.messageParent( CTAModule.MESSAGE_KEYUP )" when it wants the parent to know what's up
 * @param showFilters set if you wanna have specific filters
 *  */

interface ForceTagDecisionConstructorParams {
  tag_types: string[];
  title: string;
}

export class ForceTagDecision extends BaseModule {
  mConstructorParams?: any;
  mDiv?: JQuery<HTMLElement>;
  tagTypes?: string[];
  title?: string;
  missingTypes?: string[];

  initialize(params: ForceTagDecisionConstructorParams) {
    this.mConstructorParams = params;
    this.tagTypes = this.mConstructorParams.tag_types;
    this.title = this.mConstructorParams.title;
    this.missingTypes = [];
    this.createUI();
  }

  createUI() {
    this.generateTree();
    this.checkProfile();
  }

  generateTree() {
    var struct = { style: '', children: [] };
    this.mDiv = $(HTMLGenerator_createTree(struct));
  }

  checkProfile() {
    for (var p = 0; p < this.tagTypes!.length; p++) {
      // check the tag types
      var aTagType = this.tagTypes![p];
      var aMissingTagType = !App.INSTANCE.CurrentUser.HasPrefferedTagType(aTagType);

      if (aMissingTagType == true) {
        this.missingTypes!.push(aTagType);
      }

      // TODO: need to add dimensions
      // var aHasDimension....
    }

    if (this.missingTypes!.length > 0) {
      App.INSTANCE.onUpdateProfilePartial(this.title, { updateOnlyTagTypes: this.missingTypes });
    }
  }

  setupListeners() {
    // Check if the user is logged in and force tag decision
    App.INSTANCE.addEventListener(User.EVENT_LOGIN, () => this.checkProfile(), this);
  }

  onTransitionOut() {
    App.INSTANCE.removeEventListener(User.EVENT_LOGIN, this);
  }
}
